<video (pinchmove)="onPinch($event)" #stream></video>
<div class="buttons">
  <div class="row">
    <div class="on-off close" (click)="close()">
      <img class="icon-img" src="assets/Keen&Wise_delete_round.png">
    </div>
  </div>
  <div class="row">
    <input  *ngIf="this.cameraCapabilities?.zoom" #zoomSlider (input)="onSlide($event)"  type="range" aria-orientation="vertical" class="zoom-slider-input" name="slider" id="slider"
    [min]="zoomMin" [max]="zoomMax" [step]="zoomStep" [value]="zoomValue">
  </div>
  <div *ngIf="this.cameraCapabilities?.torch" class="row">
    <div *ngIf="!torchOn" class="on-off" (click)="toggleFlashlight()">
      <img class="icon-img" src="assets/outline_flashlight_on_white.png">
    </div>
    <div *ngIf="torchOn" class="on-off" (click)="toggleFlashlight()">
      <img class="icon-img" src="assets/outline_flashlight_off_white.png">
    </div>
  </div>
  <div class="row">
    <div class="on-off snap" (click)="snap()" [class.disabled]="!streaming">
      <img class="icon-img" src="assets/Keen&Wise_picture.png">
    </div>
  </div>
</div>
<canvas #canvas></canvas>
<img class="invisible" src="assets/outline_flashlight_off_white.png">
